import React from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';

const logoHeight = window.innerHeight * 0.1;

const App = () => (
  <div className='app'>
    <div className='logo'> <img src={"/logo.png"} alt="" height={logoHeight}/> </div>
    <Main />
  </div>
);

const Home = () => (
  <div className='home'>
    <div className='center'>
      <div className='inner'><button className='chat-link'><a href="/chat">Chat Everything</a></button></div>
      <div className='inner'><button className='chat-link'><a href="/medical">Chat Medical</a></button></div>
      <div className='inner'><button className='chat-link'><a href="/product">Chat Product</a></button></div>
      <div className='inner'><button className='chat-link'><a href="/induction">Chat Induction</a></button></div>
      <div className='inner'><button className='chat-link'><a href="/win">WIN Selling Skills</a></button></div>
    </div>
  </div>
);

const iFrameHeight = window.innerHeight * 0.8;

// const ProtectedIframe = ({ proxyPath, title }) => (
//   <div className='chat-box'>
//     <iframe
//       title={title}
//       src={proxyPath}
//       style={{ border: "1px" }}
//       width="100%"
//       height={iFrameHeight}
//       allowFullScreen
//     />
//   </div>
// );

const Chat = () => (
  <div className='chat-box'>
    <iframe title="Chat box" src="https://app.humata.ai/ask/folder/7f6c3865-1ed6-4243-b931-eee17f8ffc15?share_link=47c75e26-2286-42ab-842e-f24a2397805c" style={{border: "1px"}} width="100%" height={iFrameHeight} allowFullScreen></iframe>
  </div>
);

const ChatMedical = () => (
  <div className='chat-box'>
    <iframe title="Chat box" src="https://app.humata.ai/ask/folder/d24c99af-bb71-4526-8583-f1b9f56e31d6?share_link=cd001e3a-ce3d-42d9-af7a-798ca4363978" style={{border: "1px"}} width="100%" height={iFrameHeight} allowFullScreen></iframe>
  </div>
);

const ChatProduct = () => (
  <div className='chat-box'>
    <iframe title="Chat box" src="https://app.humata.ai/ask/folder/8e07a395-98ba-4528-bf61-404b636d42a7?share_link=7e366b08-90db-468e-ac64-d311e9e2a2fb" style={{border: "1px"}} width="100%" height={iFrameHeight} allowFullScreen></iframe>
  </div>
);

const ChatInduction = () => (
  <div className='chat-box'>
    <iframe title="Chat box" src="https://app.humata.ai/ask/folder/25c7bca0-abdf-44ab-b64b-60a099566f9b?share_link=820f70c6-24a9-426d-b1a5-9939fcb1c924" style={{border: "1px"}} width="100%" height={iFrameHeight} allowFullScreen></iframe>
  </div>
);

const ChatWin = () => (
  <div className='chat-box'>
    <iframe title="Chat box" src="https://app.humata.ai/ask/folder/39460610-b023-4640-8a05-a24f0f22dab8?share_link=0a8da1ef-0a3e-45df-a9b7-94f7d509e8a5" style={{border: "1px"}} width="100%" height={iFrameHeight} allowFullScreen></iframe>
  </div>
);
// const ChatWin = () => (
//   <ProtectedIframe proxyPath="/iframe-url/win" title="WIN Selling Skills" />
// );

const Main = () => (
  <Switch>
    <Route exact path='/' component={Home}></Route>
    <Route exact path='/chat' component={Chat}></Route>
    <Route exact path='/medical' component={ChatMedical}></Route>
    <Route exact path='/product' component={ChatProduct}></Route>
    <Route exact path='/induction' component={ChatInduction}></Route>
    <Route exact path='/win' component={ChatWin}></Route>
  </Switch>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js